var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bl-token-attribute", attrs: { id: _vm.model.id } },
    [
      _c(
        "div",
        { staticClass: "bl-token-attribute-main" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-xs btn-link",
              attrs: {
                type: "button",
                title: _vm
                  .$t(
                    "search.advanced.queryBuilder.attribute_delete_attribute_button_title"
                  )
                  .toString(),
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("delete-attribute", _vm.model.id)
                },
              },
            },
            [
              _c("span", {
                staticClass: "glyphicon glyphicon-remove text-primary",
              }),
            ]
          ),
          _vm._v(" "),
          _c("SelectPicker", {
            attrs: {
              "data-attribute-role": "type",
              options: _vm.options.annotationOptions,
              hideEmpty: "",
              "data-width": "75px",
              "data-menu-width": "auto",
              container: "body",
              "data-class": "btn btn-sm btn-default bl-no-border-radius-right",
            },
            model: {
              value: _vm.model.annotationId,
              callback: function ($$v) {
                _vm.$set(_vm.model, "annotationId", $$v)
              },
              expression: "model.annotationId",
            },
          }),
          _vm._v(" "),
          _c("SelectPicker", {
            attrs: {
              "data-attribute-role": "operator",
              options: _vm.options.comparatorOptions,
              "data-width": "50px",
              "data-menu-width": "auto",
              hideEmpty: "",
              hideCaret: "",
              container: "body",
              "data-class": "btn btn-sm btn-primary bl-no-border-radius",
            },
            model: {
              value: _vm.model.comparator,
              callback: function ($$v) {
                _vm.$set(_vm.model, "comparator", $$v)
              },
              expression: "model.comparator",
            },
          }),
          _vm._v(" "),
          _vm.hasUploadedValue
            ? _c(
                "button",
                {
                  staticClass:
                    "btn btn-default btn-sm bl-no-border-radius bl-token-attribute-main-input",
                  staticStyle: { "text-align": "auto" },
                  attrs: {
                    type: "button",
                    "data-attribute-role": "value",
                    title: _vm
                      .$t(
                        "search.advanced.queryBuilder.attribute_file_upload_edit_button_title"
                      )
                      .toString(),
                  },
                  on: { click: _vm.openModalEditor },
                },
                [
                  _c("span", { staticClass: "glyphicon glyphicon-edit" }),
                  _vm._v(
                    "\n\t\t\t" + _vm._s(_vm.uploadedValuesSummary) + "\n\t\t"
                  ),
                ]
              )
            : _vm.currentAnnotation?.values
            ? _c("SelectPicker", {
                staticClass: "bl-token-attribute-main-input",
                attrs: {
                  "data-attribute-role": "value",
                  options: _vm.currentAnnotation.values.map((v) => ({
                    ...v,
                    value: _vm.escapeRegex(v.value),
                  })),
                  multiple: "",
                  searchable: "",
                  container: "body",
                  "data-menu-width": "auto",
                  "data-class":
                    "btn btn-default btn-sm bl-no-border-radius bl-token-attribute-main-input",
                  value: _vm.model.values,
                },
                on: {
                  input: function ($event) {
                    _vm.model.values =
                      $event ||
                      [] /* workaround for querbuilder emitting null sometimes */
                  },
                },
              })
            : _c("Autocomplete", {
                staticClass:
                  "form-control input-sm bl-no-border-radius bl-token-attribute-main-input",
                attrs: {
                  "data-attribute-role": "value",
                  type: "text",
                  dir: _vm.textDirection,
                  url: _vm.autocompleteUrl,
                  useQuoteAsWordBoundary: "",
                },
                model: {
                  value: _vm.textValue,
                  callback: function ($$v) {
                    _vm.textValue = $$v
                  },
                  expression: "textValue",
                },
              }),
          _vm._v(" "),
          !_vm.hasUploadedValue
            ? _c(
                "label",
                {
                  staticClass:
                    "btn btn-sm btn-default bl-no-border-radius bl-input-upload-button",
                  attrs: {
                    title: _vm
                      .$t(
                        "search.advanced.queryBuilder.attribute_file_upload_button_title"
                      )
                      .toString(),
                  },
                },
                [
                  _c("input", {
                    staticStyle: { display: "none" },
                    attrs: {
                      type: "file",
                      accept: "text/*",
                      title: _vm.$t(
                        "search.advanced.queryBuilder.attribute_file_upload_button_title"
                      ),
                    },
                    on: { change: _vm.handleFileUpload },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "glyphicon glyphicon-open" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(
                      _vm._s(
                        _vm
                          .$t(
                            "search.advanced.queryBuilder.attribute_file_upload_button_title"
                          )
                          .toString()
                      )
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("CqlAddAttributeButton", {
            attrs: { options: _vm.options },
            on: {
              click: function ($event) {
                return _vm.emitAddAttributeGroup($event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.currentAnnotation && _vm.currentAnnotation.caseSensitive
        ? _c(
            "label",
            { staticClass: "bl-token-attribute-case-and-diacritics-sensitive" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model.caseSensitive,
                    expression: "model.caseSensitive",
                  },
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.model.caseSensitive)
                    ? _vm._i(_vm.model.caseSensitive, null) > -1
                    : _vm.model.caseSensitive,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.model.caseSensitive,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.model,
                            "caseSensitive",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.model,
                            "caseSensitive",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.model, "caseSensitive", $$c)
                    }
                  },
                },
              }),
              _vm._v(
                "\n\t\t" +
                  _vm._s(
                    _vm.$t(
                      "search.advanced.queryBuilder.attribute_caseAndDiacriticsSensitive"
                    )
                  ) +
                  "\n\t"
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showModal
        ? _c("Modal", {
            attrs: {
              size: "sm",
              title: _vm.$t("search.advanced.queryBuilder.modalEditor_title"),
              closeMessage: _vm.$t(
                "search.advanced.queryBuilder.modalEditor_cancel"
              ),
              confirmMessage: _vm.$t(
                "search.advanced.queryBuilder.modalEditor_save"
              ),
            },
            on: {
              close: _vm.closeModalEditor,
              confirm: _vm.confirmModalEditor,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.uploadedValue,
                            expression: "model.uploadedValue",
                          },
                        ],
                        staticClass: "form-control",
                        staticStyle: {
                          width: "100%",
                          overflow: "auto",
                          resize: "none",
                          "white-space": "pre",
                        },
                        attrs: { rows: "10" },
                        domProps: { value: _vm.model.uploadedValue },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.model,
                              "uploadedValue",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger pull-left",
                          attrs: { type: "button" },
                          on: { click: _vm.clearModalEditor },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "search.advanced.queryBuilder.modalEditor_clear"
                                )
                              ) +
                              "\n\t\t\t"
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              645739460
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }